export const WHATSAPP_NUMBER = "966554713287";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const WHATSAPP_DISPLAY = "+(966) 554713287";
